import NewReleasesIcon from "@mui/icons-material/NewReleases"
import { Box, styled, Typography } from "@mui/material"
import React from "react"
import { pxToRem } from "utils/helpers"

interface FewSpotsLeftProps {
  className?: string
}

const FewSpotsLeft = (props: FewSpotsLeftProps) => {
  const { className } = props

  return (
    <_Container className={className}>
      <NewReleasesIcon aria-hidden={true} color="inherit" />
      <Typography color="inherit" variant="paragraphItalic">
        Only a few spots left!
      </Typography>
    </_Container>
  )
}

export default FewSpotsLeft

const _Container = styled(Box)(() => ({
  display: "flex",
  flexFlow: "row nowrap",
  alignItems: "center",
  gap: pxToRem(4),
  color: "inherit",
}))
